import ChangePassword from "./changePassword";
import ForgotPassword from "./forgotPassword";
import LoginField from "./loginField";
import VerifyOTP from "./verifyOTP";

const loginComponentMap: Record<string, React.ComponentType> = {
  LOGIN: LoginField,
  VERIFY_PHONE: VerifyOTP,
  VERIFY_EMAIL: VerifyOTP,
  FORGOT_PASSWORD_EMAIL: ForgotPassword,
  FORGOT_PASSWORD_NUM: ForgotPassword,
  CHANGE_PASSWORD: ChangePassword,
};

export default loginComponentMap;
